import { Flex, RootScreen } from '@banhala/ui-kit';
import { useSetScreenName, useReportTTFD } from '../../hooks';
import { ScreensResult } from '../../components';
import { FilterListAtomicProvider } from 'shared/src/component';

export const FragmentScreens = () => {
  useSetScreenName();
  useReportTTFD();

  return (
    <RootScreen>
      <Flex flex={1}>
        <FilterListAtomicProvider>
          <ScreensResult />
        </FilterListAtomicProvider>
      </Flex>
    </RootScreen>
  );
};
